import React, { FC } from 'react';

interface IGitBookProps {
	color?: string;
	size: number;
}

export const GitBook: FC<IGitBookProps> = (props) => {
	return (
		<svg
			width={props.size}
			height={props.size}
			version="1.2"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 654 474"
			{...props}
		>
			<path
				id="Layer"
				fillRule="evenodd"
				d="m654 257.6c0 32.8-26.6 59.5-59.3 59.5-13.2 0-26.5-4.1-36.7-12.3l-204.4 110.8c-1 32.8-26.5 58.4-59.2 58.4-28.6 0-54.2-22.6-58.3-51.3l-185.9-96.4c-30.7-15.3-52.1-59.4-50.1-101.5 1.1-26.6 12.3-48.2 29.7-58.4 10.2-6.2 189-94.4 318.7-160 3.1-2 23.5-13.3 48 0 28.6 15.4 94 46.2 151.2 72.8 26.6 12.3 54.2 25.6 72.6 33.9 0 0 9.2 4.1 9.2 13.3 0 7.2-5.1 11.3-10.2 13.3l-314.7 164.1c-17.4 8.2-22.5 6.1-32.7 2-6.1-3-159.4-84.1-206.4-108.7-7.1-3-12.2-4.1-17.3-1-7.2 4.1-12.3 15.4-13.3 29.7-2.1 28.8 12.2 58.5 30.6 68.8l175.7 92.2c10.3-19.4 30.7-32.8 53.2-32.8 19.4 0 37.8 9.3 49 25.7l195.2-104.6q-3.1-9.3-3.1-18.5c0-32.8 26.6-59.5 59.2-59.5 32.7 0 59.3 26.7 59.3 60.5zm-39.8-1c0-11.3-9.2-19.5-19.5-19.5-11.2 0-19.4 9.3-19.4 19.5 0 11.3 9.2 19.5 19.4 19.5 10.3 0 19.5-9.2 19.5-19.5zm-339.2 157.9c0 11.3 9.2 19.5 19.4 19.5 11.2 0 19.4-9.2 19.4-19.5 0-11.3-9.2-19.5-19.4-19.5-10.2 0-19.4 8.2-19.4 19.5z"
				fill={props.color ?? '#fff'}
			/>
		</svg>
	);
};
